import { Routes } from '@angular/router';
import { ActivarComponent } from './activar.component';

/** Ruta pública de activación de usuario (sin guard de autenticación). */
export const ACTIVAR_ROUTES: Routes = [
  {
    path: '',
    component: ActivarComponent,
  },
];
